import { translate, type Locale } from '@shared/config/i18n'

const NUMBER_LOCALE_BY_LOCALE = {
  ko: 'ko-KR',
  en: 'en-US',
  ja: 'ja-JP',
} satisfies Record<Locale, string>

export const formatKrwAmount = (amount: number | null | undefined, locale: Locale = 'ko') => {
  const safeAmount = Number(amount ?? 0)

  if (locale === 'ko') {
    return `${safeAmount.toLocaleString(NUMBER_LOCALE_BY_LOCALE.ko)}${translate(locale, 'common.currency.krwSuffix')}`
  }

  return new Intl.NumberFormat(NUMBER_LOCALE_BY_LOCALE[locale], {
    style: 'currency',
    currency: 'KRW',
    maximumFractionDigits: 0,
  }).format(safeAmount)
}
